import { matchPath, useLocation } from 'react-router-dom';

import { useFeatureFlag } from 'api/configuration/features/hooks/useFeatureFlag';
import { projectPaths } from 'app/routes/paths/project';

type UseProposalContextResult = {
  projectId: string | undefined;
  proposalId: string | undefined;
  isInProposal: boolean;
};

export const useProposalContext = (): UseProposalContextResult => {
  const location = useLocation();
  const isProjectVersioningEnabled = useFeatureFlag('ProjectVersioning');

  const matchProjectRoute = matchPath<{ projectId: string }>(location.pathname, {
    path: [`${projectPaths.BASE}`, `${projectPaths.BASE}/*`]
  });

  const matchProposalRoute = matchPath<{ proposalId: string; projectId: string }>(location.pathname, {
    path: [`${projectPaths.BASE}/proposals/:proposalId`, `${projectPaths.BASE}/proposals/:proposalId/*`]
  });

  const projectId = matchProjectRoute?.params?.projectId;
  const proposalId = matchProposalRoute?.params?.proposalId;
  const isInProposal = Boolean(proposalId) && isProjectVersioningEnabled;

  return { projectId, proposalId, isInProposal };
};
